// The code in this file will load on every page of your site

$w.onReady(function () {
	// Write your code here
});

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/

let menu = '#impressiveSideMenu1';
export function button13_click() {
	if(menu == "false"){
$w("#impressiveSideMenu1").show();
console.log("1");
	}if(menu == "true"){
		$w("#impressiveSideMenu1").hide();
console.log("2");
	}
	



}